import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useCart } from '../../lib/cart'
import { formatPrice } from '../../lib/format'

export default function Cart() {
  const { items, total, currency, loading, updateQty, remove, refresh } = useCart()

  // Always pull a fresh cart when landing here (another tab may have changed it).
  useEffect(() => { void refresh() }, [refresh])

  if (loading && items.length === 0) {
    return <div className="shop-state">Loading your basket…</div>
  }

  if (items.length === 0) {
    return (
      <div className="cart-empty" data-testid="cart-empty">
        <h1>Your basket is empty</h1>
        <Link to="/shop" className="btn-primary">Continue shopping</Link>
      </div>
    )
  }

  return (
    <div className="cart" data-testid="cart">
      <h1 className="shop-page-title">Your basket</h1>
      <ul className="cart-lines">
        {items.map((i) => (
          <li key={i.id} className="cart-line" data-testid="cart-line">
            <div className="cart-line-img">
              {i.product.imageUrls?.[0] && <img src={i.product.imageUrls[0]} alt={i.product.title} />}
            </div>
            <div className="cart-line-info">
              <div className="cart-line-title">{i.product.title}</div>
              {i.productVariant.option1 && (
                <div className="cart-line-variant">{i.productVariant.option1}</div>
              )}
              <div className="cart-line-unit">{formatPrice(i.productVariant.price, i.product.currency)} each</div>
            </div>
            <div className="cart-line-qty" data-testid="cart-line-qty">
              <button
                aria-label="Decrease quantity"
                onClick={() => updateQty(i.id, Math.max(1, i.quantity - 1))}
              >−</button>
              <span>{i.quantity}</span>
              <button
                aria-label="Increase quantity"
                onClick={() => updateQty(i.id, i.quantity + 1)}
              >+</button>
            </div>
            <div className="cart-line-price">{formatPrice(i.totalPrice, i.product.currency)}</div>
            <button
              className="cart-line-remove"
              aria-label="Remove item"
              data-testid="cart-line-remove"
              onClick={() => remove(i.id)}
            >×</button>
          </li>
        ))}
      </ul>
      <div className="cart-footer">
        <div className="cart-total">
          Total <strong data-testid="cart-total">{formatPrice(total, currency)}</strong>
        </div>
        <Link to="/checkout" className="btn-primary cart-checkout" data-testid="checkout-button">
          Checkout
        </Link>
      </div>
    </div>
  )
}
